import { render, staticRenderFns } from "./claim.vue?vue&type=template&id=421f7de8&"
import script from "./claim.vue?vue&type=script&lang=js&"
export * from "./claim.vue?vue&type=script&lang=js&"
import style0 from "./claim.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports